import { render, staticRenderFns } from "./ModalSatuSehat.vue?vue&type=template&id=01f999ee&"
import script from "./ModalSatuSehat.vue?vue&type=script&lang=js&"
export * from "./ModalSatuSehat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports